import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { useLang } from "./i18n";

const Ctx = createContext(null);
const KEY = "og_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  const { t } = useLang();

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (p, size, color) => {
    setItems((cur) => {
      const k = `${p.id}-${size}${color ? "-" + color : ""}`;
      const ex = cur.find((i) => i.key === k);
      if (ex) return cur.map((i) => (i.key === k ? { ...i, qty: i.qty + 1 } : i));
      return [...cur, { key: k, id: p.id, name: p.name, price: p.price, img: p.imgs[0], size, color, pre: p.pre, qty: 1 }];
    });
    toast(`${p.name} — ${size}`, { description: t("prod.added") });
  };
  const setQty = (key, qty) =>
    setItems((cur) => (qty <= 0 ? cur.filter((i) => i.key !== key) : cur.map((i) => (i.key === key ? { ...i, qty } : i))));

  const count = items.reduce((a, i) => a + i.qty, 0);
  const total = items.reduce((a, i) => a + i.qty * i.price, 0);

  return <Ctx.Provider value={{ items, add, setQty, count, total, open, setOpen }}>{children}</Ctx.Provider>;
};

export const useCart = () => useContext(Ctx);
